import { useAppSelector } from '../../store/hooks';
import { selectAuthState } from '../../store/slices/header.slice';
import { Redirect } from '@reach/router';

export const Loading: React.FC = () => {
  const isAuthenticated = useAppSelector(selectAuthState);

  if (isAuthenticated) {
    return <Redirect to="/patients"></Redirect>;
  } else {
    return null;
  }
};

export default Loading;
